import { useState } from "react";
import { mastheadNav } from "@/mocks/homeData";

export default function Masthead() {
  const [keyword, setKeyword] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="flex flex-col gap-4 py-4 md:flex-row md:items-center md:justify-between md:py-5">
          <div className="flex items-center justify-between">
            <div className="flex items-end gap-3">
              <h1 className="font-heading text-3xl font-black leading-none tracking-tight text-foreground-950 md:text-[40px]">
                黑料社网
              </h1>
              <span className="hidden flex-col leading-tight sm:flex">
                <span className="text-[10px] font-semibold uppercase tracking-[0.3em] text-primary-600">
                  the gossip daily
                </span>
                <span className="text-[11px] text-foreground-500">今日黑料 · 热门爆料 · 头条新料</span>
              </span>
            </div>

            <button
              type="button"
              onClick={() => setMenuOpen((prev) => !prev)}
              aria-label="展开导航"
              className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-800 md:hidden"
            >
              <i className={menuOpen ? "ri-close-line text-lg" : "ri-menu-line text-lg"} />
            </button>
          </div>

          <div className="flex items-center gap-3">
            <div className="flex flex-1 items-center gap-2 rounded-full border border-background-300 bg-background-100 px-4 py-2 md:w-72 md:flex-none">
              <i className="ri-search-line text-sm text-foreground-500" />
              <input
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                placeholder="搜索爆料 / 话题 / 关键词"
                className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-500"
              />
            </div>
            <button
              type="button"
              className="hidden cursor-pointer whitespace-nowrap rounded-full bg-primary-500 px-5 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950 sm:block"
            >
              关注本站
            </button>
          </div>
        </div>

        <nav className="hidden items-center gap-1 border-t border-background-200 py-2.5 md:flex">
          <a
            href="#top"
            className="rounded-md px-3 py-1.5 text-sm font-medium text-primary-600 transition-colors hover:bg-primary-50"
          >
            首页
          </a>
          {mastheadNav.map((item) => (
            <a
              key={item.label}
              href={item.href}
              className="rounded-md px-3 py-1.5 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-foreground-950"
            >
              {item.label}
            </a>
          ))}
          <span className="ml-auto flex items-center gap-3 text-xs text-foreground-500">
            <span className="flex items-center gap-1">
              <i className="ri-calendar-line" />
              2026.09.12 周六
            </span>
            <span className="h-3 w-px bg-background-300" />
            <span>第 128 期 · 今日已更新 46 条</span>
          </span>
        </nav>

        {menuOpen && (
          <nav className="flex flex-col gap-1 border-t border-background-200 py-3 md:hidden">
            <a
              href="#top"
              className="rounded-md px-3 py-2 text-sm font-medium text-primary-600"
              onClick={() => setMenuOpen(false)}
            >
              首页
            </a>
            {mastheadNav.map((item) => (
              <a
                key={item.label}
                href={item.href}
                className="rounded-md px-3 py-2 text-sm text-foreground-700 hover:bg-background-100"
                onClick={() => setMenuOpen(false)}
              >
                {item.label}
              </a>
            ))}
          </nav>
        )}
      </div>
    </header>
  );
}